import React from "react";
import { useNavigate } from "react-router-dom";
import { EndCreateMission, Plus } from "assets/icons";
import Banner from "components/banner/banner";
import Button from "components/button";
import ApiDataBase from "server";
import UseContext from "hooks/useContext";
import { toast } from "react-toastify";

/**
 * savedJobPostDoc : document renvoyé par l’API après POST/PATCH réussi (création / édition).
 * editTemplateRouteId : id URL en mode edit (fallback si pas de corps de réponse avec _id).
 */
const EndTemplate = ({
    mode = "create",
    savedJobPostDoc,
    editTemplateRouteId,
}) => {
    const navigate = useNavigate();
    const {
        companyData,
        setSelectedJobPostTemplate,
        setPage,
    } = UseContext();

    const templateId = savedJobPostDoc?._id
        ? String(savedJobPostDoc._id)
        : editTemplateRouteId
        ? String(editTemplateRouteId)
        : null;

    /** Désactivation immédiate si le dernier corps API le signale ; vérif définitive après GET mission. */
    const missionCreationBlocked =
        savedJobPostDoc?.isBelowMinimumWage === true;

    const missionButtonTitle =
        "Créer une mission à partir de cette fiche de poste";

    const handleNavigation = () => navigate("/jobPostTemplates");

    const handleCreateMissionFromTemplate = () => {
        if (!templateId) {
            toast.error("Impossible de déterminer la fiche de poste.");
            return;
        }
        if (!companyData?._id) {
            toast.error(
                "Impossible de déterminer votre entreprise courante."
            );
            return;
        }
        if (missionCreationBlocked) {
            toast.warning(
                "Cette fiche est inférieure au SMIC : vous ne pouvez pas créer de mission depuis celle-ci."
            );
            return;
        }

        ApiDataBase.getJobPostTemplate(
            { id: templateId },
            (template) => {
                if (template?.isBelowMinimumWage) {
                    toast.warning(
                        "Cette fiche est inférieure au SMIC : création de mission impossible."
                    );
                    return;
                }
                setSelectedJobPostTemplate(template);
                setPage(0);
                navigate("/createOfMission");
            },
            (err) => {
                console.error(err);
                toast.error("Impossible de charger la fiche de poste.");
            }
        );
    };

    const title =
        mode === "edit"
            ? "Fiche de poste mise à jour 🎉"
            : "Fiche de poste créée avec succès 🎉";
    const description =
        mode === "edit"
            ? "Les modifications ont bien été enregistrées."
            : "Vous pouvez désormais l'utiliser pour créer des missions plus rapidement.";

    const showMissionButton = Boolean(templateId);

    return (
        <div className={"flex flex-col gap-4"}>
            <p className={"ft-sm text-yellow-500"}>Félicitations !</p>
            <h1 className={"ft-xl text-gray-900 font-medium"}>{title}</h1>
            <p className={"ft-sm text-gray-500"}>{description}</p>
            <Banner type={"info"}>
                Retrouvez vos fiches de postes dans la rubrique “Fiches de
                postes” de la barre latérale.
            </Banner>
            <div className={"mx-auto"}>
                <EndCreateMission w={350} h={180} />
            </div>
            <div className="flex flex-wrap justify-end gap-3 mt-10">
                <Button size={"LG"} color={"SECONDARY"} onClick={handleNavigation}>
                    Retour aux fiches
                </Button>
                {showMissionButton && (
                    <Button
                        size={"LG"}
                        color={"PRIMARY"}
                        disabled={missionCreationBlocked}
                        onClick={handleCreateMissionFromTemplate}
                        aria-label={missionButtonTitle}
                    >
                        <Plus wh={18} color="#FFFFFF" />
                        <span className="ml-1">{missionButtonTitle}</span>
                    </Button>
                )}
            </div>
            {missionCreationBlocked && showMissionButton && (
                <p className="ft-xs text-red-600 text-right max-w-xl ml-auto">
                    Cette fiche est inférieure au SMIC (non indexée) : création de
                    mission désactivée.
                </p>
            )}
        </div>
    );
};

export default EndTemplate;
